import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import label from "../../../common/labels/common_en.json";
import { uploadMastersData, getAllMasterTypes, downloadSampleCSVFile, uploadDataByUsingCron, getFileUploadStatus, downloadErrorCSVFile } from "../../../common/actions/commonActions";
import { DatePicker, Space } from 'antd';
import dayjs from "dayjs";
import { toastr } from "react-redux-toastr";
import moment from 'moment';
import { SET_FILE_UPLOAD_STATUS } from "../../../common/constants/ActionTypes";


function MastersCsvImport() {

  const { register, handleSubmit, errors, reset } = useForm({
    mode: "onChange",
  });

  const fileInputRef = useRef(null);

  const [selectedUploadFile, setSelectedUploadFile] = useState("");
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [reloadItem, setReloadItem] = useState(true);
  const [selectedType, setSelectedType] = useState("");
  const [allTypes, setAllTypes] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [typeId, setTypeId] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getAllMasterTypes());
    dispatch({
      payload: {},
      type: SET_FILE_UPLOAD_STATUS,
    });
  }, []);

  let { masterTypesList, fileUploadStatus } = useSelector((state) => state.common, shallowEqual);

  useEffect(() => {
    setAllTypes(masterTypesList);
  }, [masterTypesList]);

  useEffect(() => { }, [reloadItem]);

  useEffect(() => {
    if (saveButtonFlag) {
      onCancelButton();
    }
  }, [saveButtonFlag]);

  function formatDate(inputDateString) {
    const inputDate = new Date(inputDateString);

    const year = inputDate.getUTCFullYear();
    const month = String(inputDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(inputDate.getUTCDate()).padStart(2, '0');
    const hours = String(inputDate.getUTCHours()).padStart(2, '0');
    const minutes = String(inputDate.getUTCMinutes()).padStart(2, '0');
    const seconds = String(inputDate.getUTCSeconds()).padStart(2, '0');

    const formattedDate = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

    return formattedDate;
  }


  const handleClearFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  const onTypeChange = (ele) => {
    let selType = ele;
    setSelectedType(selType);
    if (ele == '') {
      onCancelButton()
    } else {
      let getSelDate = allTypes.find(item => item.type === ele);
      setSelectedDate(getSelDate.updateDataAfter !== null ? formatDate(getSelDate.updateDataAfter) : "");
      const type = allTypes.find(type => type.type === selType);
      dispatch(getFileUploadStatus(type.id));
      setTypeId(type.id);
      setReloadItem(!reloadItem);
    }

  };


  const onChange = (value, dateString) => {
    if (dateString) {
      setSelectedDate(dateString)
    } else {
      setSelectedDate("")
    }
  };

  const onCancelButton = () => {
    // setSelectedType("");
    // setSelectedUploadFile("");
    setSelectedType("");
    setSelectedDate("");
    reset();
    dispatch({
      payload: {},
      type: SET_FILE_UPLOAD_STATUS,
    });
    setSaveButtonFlag(true);
  };


  const onSubmit = (e) => {

    if (selectedUploadFile && selectedUploadFile.size > label.FILE_SIZE_LIMIT * 1024 * 1024) {
      toastr.warning(label.FileSizeExceeds, label.FileIsBeingUploaded);
      let data = {};
      data.file = selectedUploadFile;
      data.csvUploadConfigId = typeId;
      dispatch(uploadDataByUsingCron(data, selectedDate));
      onCancelButton();
    } else {
      let data = {};
      data.file = selectedUploadFile;
      data.type = "importData";
      dispatch(uploadMastersData(selectedType, data, setSelectedType, selectedDate));
      onCancelButton();
    }

  };

  const handleSampleDownload = (type) => {
    dispatch(downloadSampleCSVFile(type));
  };

  const handleErrorCSV = (type, id) => {
    dispatch(downloadErrorCSVFile(type, id));
  };

  const onUploadFileChange = (e) => {
    if (e.target.files.length === 0) {
      return;
    }
    setSaveButtonFlag(false);
    let selectedValue = e.target.files[0];
    setSelectedUploadFile(selectedValue);
    setReloadItem(!reloadItem);
  };

  return (
    <div className="dashboardContentArea">
      <h5> {label.MastersCsvImport} </h5>
      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">

                {/* <div className="col-md-2" >
                  <label className="float-left w-100">
                    Select Date
                    <span className="errorText">*</span>
                  </label>
                  <DatePicker defaultValue={dayjs('2023-08-04T00:00:00.000+00:00', dateFormat)} format={dateFormat} />
                </div> */}
                <div className="form-group col-md-3">
                  <label className="float-left">
                    {label.SelectType}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedType"
                    // value={selectedType}
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onTypeChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {label.COMBO_SELECT}
                    </option>
                    {allTypes &&
                      allTypes.length > 0 &&
                      allTypes.map((element, index) => (
                        <option key={index} value={element.type}>
                          {element.name}
                        </option>
                      ))}
                  </select>
                  {_.get("selectedType.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {label.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>

                <div className="form-group col-md-3">
                  <label className="float-left">
                    Update Data From Date
                  </label>
                  <Space direction="vertical" size={12}>
                    <DatePicker
                      allowClear
                      showTime={{
                        format: 'HH:mm',
                      }}
                      format="YYYY/MM/DD HH:mm"
                      value={selectedDate && dayjs(selectedDate, 'YYYY/MM/DD HH:mm')}
                      onChange={onChange}
                    />
                  </Space>
                </div>

                <div className="form-group col-md-3">
                  <label className="float-left">
                    {label.SelectUploadFile}
                    <span className="errorText">*</span>
                  </label>
                  <input
                    className="form-control mt-1"
                    type="file"
                    ref={fileInputRef}
                    accept=".xlsx, .xls, .csv"
                    name="selectedUploadFile"
                    onChange={(e) => {
                      onUploadFileChange(e);
                    }}
                  />
                  {_.get("selectedUploadFile.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {label.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-6 mt-3 d-flex align-items-center">
                  <button
                    type="reset"
                    className="btn btn-secondary mr-2 "
                    onClick={() => onCancelButton()}
                  >
                    {label.BUTTON_CANCEL}
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={saveButtonFlag}
                    onClick={handleSubmit((e) => {
                      onSubmit(e);
                      handleClearFile();
                    })}
                  >
                    {label.BUTTON_IMPORT}
                  </button>
                  <div className="float-right">
                    <i
                      className={"fa fa-file-excel-o ml-2 fa-2x text-success"}
                      aria-hidden="true"
                      onClick={() => {
                        if (selectedType !== "") {
                          handleSampleDownload(selectedType);
                        }
                      }}
                      style={{ cursor: selectedType === "" ? "not-allowed" : "pointer" }}
                      title={selectedType === "" ? label.SELECTTYPE : label.DOWNLOADTEMPLATE}
                    ></i>
                  </div>
                </div>
                {selectedType && fileUploadStatus && fileUploadStatus.fileUploadStatusDtos && fileUploadStatus.fileUploadStatusDtos.length > 0 && (
                  <div className="form-group col-md-12">
                    <h5>File Upload Status</h5>
                    <table className="table table-bordered text-center">
                      <thead className="bold-label">
                        <tr>
                          <th>{label.SrNo}</th>
                          <th>{label.TYPE}</th>
                          <th>{label.STATUS}</th>
                          <th>{label.UPLOADEDDATE}</th>
                          <th>{label.NOOFRECORDSADDED}</th>
                          <th>{label.ERRORFILE}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {fileUploadStatus && fileUploadStatus.fileUploadStatusDtos.map((statusObj, index) => (
                          <React.Fragment key={index}>
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{statusObj.type}</td>
                              <td>{statusObj.status}</td>
                              <td>{moment(statusObj.updateDateAfter).format('DD/MM/YYYY HH:mm:ss')}</td>
                              <td>{statusObj.noOfRecords || 0}</td>
                              <td>
                                {statusObj.flgErrorCsv === true ? (
                                  <i
                                    className={"fa fa-file-excel-o ml-2 fa-2x text-success"}
                                    aria-hidden="true"
                                    onClick={() => {
                                      if (selectedType !== "") {
                                        handleErrorCSV(selectedType, statusObj.id);
                                      }
                                    }}
                                    style={{ cursor: selectedType === "" ? "not-allowed" : "pointer" }}
                                    title={selectedType === "" ? label.SELECTTYPE : label.DOWNLOADERRORFILE}
                                  ></i>
                                ) : (
                                  <span>-</span>
                                )}
                              </td>
                            </tr>
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>
                  </div>)}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default MastersCsvImport;
